<template>
  <div class="container">
    <div class="wrap">
      <v-stepper :class="{'v-stepper-mobile': isMobile}" v-model="$route.query.step" :vertical="isMobile">
        <div class="v-stepper__headerBox" v-if="!isMobile">
          <v-stepper-header>
            <v-stepper-step
              step="1"
              :editable="currentStep > 1"
              :complete="currentStep > 1"
              :edit-icon="'done'"
              @click="onStepClick(1)"
              >{{
                localStorage.translations.pages.sales_project.sections[
                  'proektnye-i-klientskie-dannye'
                ]
              }}</v-stepper-step
            >
            <v-divider :class="{ complete: currentStep > 1 }" />
            <template v-if="companiesConfig.schemes !== '0' || companiesConfig.documents !== '0'">
              <v-stepper-step
                :editable="currentStep > 2"
                step="2"
                :complete="currentStep > 2"
                :edit-icon="'done'"
                @click="onStepClick(2)"
              >{{
                  localStorage.translations.pages.sales_project.sections['chertezhi-i-dokumenty']
                }}</v-stepper-step
              >
              <v-divider :class="{ complete: currentStep > 2 }" />
            </template>
            <template v-if="companiesConfig.work_type_prices !== '0' || companiesConfig.extra_work_price !== '0'">
              <v-stepper-step
                :editable="currentStep > 3"
                step="3"
                :complete="currentStep > 3"
                :edit-icon="'done'"
                @click="onStepClick(3)"
              >{{
                  localStorage.translations.pages.sales_project.sections['materialy-i-tseny']
                }}</v-stepper-step
              >
              <v-divider :class="{ complete: currentStep > 3}" />
            </template>
            <v-stepper-step step="4" :complete="currentStep > 4" :edit-icon="'done'">{{
              localStorage.translations.pages.sales_project.sections['planiruemye-resursy']
            }}</v-stepper-step>
          </v-stepper-header>
          <BaseButton
            @click="nextStep"
            icon_right
            :text="
              currentStep == 4
                ? localStorage.translations.pages.sales_project.buttons['sozdat-proekt']
                : localStorage.translations.pages.sales_project.buttons['prodolzhit']
            "
            :default_icon="currentStep === 4 ? 'button-done' : 'button-continue'"
          />
        </div>
        <v-stepper-items>
          <v-stepper-step
            v-if="isMobile"
            step="1"
            :editable="currentStep > 1"
            :complete="currentStep > 1"
            :edit-icon="'done'"
            @click="onStepClick(1)"
            >{{
              localStorage.translations.pages.sales_project.sections[
                'proektnye-i-klientskie-dannye'
              ]
            }}</v-stepper-step
          >
          <v-stepper-content step="1">
            <ProjectDesignAndCustomer
              ref="ProjectDesignAndCustomer"
              :createContinue="SalesProjectCreateContinue"
              :edit="true"
            />
            <BaseButton
              v-if="isMobile"
              class="mt-4"
              @click="nextStep"
              icon_right
              :text="
                currentStep == 4
                  ? localStorage.translations.pages.sales_project.buttons['sozdat-proekt']
                  : localStorage.translations.pages.sales_project.buttons['prodolzhit']
              "
              :default_icon="currentStep === 4 ? 'button-done' : 'button-continue'"
            />
          </v-stepper-content>
          <template v-if="companiesConfig.schemes !== '0' || companiesConfig.documents !== '0'">
            <v-stepper-step
              v-if="isMobile"
              :editable="currentStep > 2"
              step="2"
              :complete="currentStep > 2"
              :edit-icon="'done'"
              @click="onStepClick(2)"
            >{{
                localStorage.translations.pages.sales_project.sections['chertezhi-i-dokumenty']
              }}</v-stepper-step
            >
            <v-stepper-content step="2">
              <ProjectSchemesAndDocuments ref="ProjectSchemesAndDocuments" :edit="true" :tableSticky="false"/>
              <BaseButton
                v-if="isMobile"
                class="mt-4"
                @click="nextStep"
                icon_right
                :text="
                currentStep == 4
                  ? localStorage.translations.pages.sales_project.buttons['sozdat-proekt']
                  : localStorage.translations.pages.sales_project.buttons['prodolzhit']
              "
                :default_icon="currentStep === 4 ? 'button-done' : 'button-continue'"
              />
            </v-stepper-content>
          </template>
          <template v-if="companiesConfig.work_type_prices !== '0' || companiesConfig.extra_work_price !== '0'">
            <v-stepper-step
              v-if="isMobile"
              :editable="currentStep > 3"
              step="3"
              :complete="currentStep > 3"
              :edit-icon="'done'"
              @click="onStepClick(3)"
            >{{
                localStorage.translations.pages.sales_project.sections['materialy-i-tseny']
              }}</v-stepper-step
            >
            <v-stepper-content step="3">
              <ProjectMaterialsAndPrices ref="ProjectMaterialsAndPrices" :edit="true" :tableSticky="false" />
              <BaseButton
                v-if="isMobile"
                class="mt-4"
                @click="nextStep"
                icon_right
                :text="
                currentStep == 4
                  ? localStorage.translations.pages.sales_project.buttons['sozdat-proekt']
                  : localStorage.translations.pages.sales_project.buttons['prodolzhit']
              "
                :default_icon="currentStep === 4 ? 'button-done' : 'button-continue'"
              />
            </v-stepper-content>
          </template>
          <v-stepper-step
            v-if="isMobile"
            step="4"
            :complete="currentStep > 4"
            :edit-icon="'done'"
            >{{
              localStorage.translations.pages.sales_project.sections['planiruemye-resursy']
            }}</v-stepper-step
          >
          <v-stepper-content step="4">
            <ProjectPlannedResources
              ref="ProjectPlannedResources"
              :step="'4'"
              :createContinue="SalesProjectCreateContinue"
              :edit="true"
            />
            <BaseButton
              v-if="isMobile"
              class="mt-4"
              @click="nextStep"
              icon_right
              :text="
                currentStep == 4
                  ? localStorage.translations.pages.sales_project.buttons['sozdat-proekt']
                  : localStorage.translations.pages.sales_project.buttons['prodolzhit']
              "
              :default_icon="currentStep === 4 ? 'button-done' : 'button-continue'"
            />
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>
  </div>
</template>

<script>
// import ButtonContinue from 'components/ButtonContinue'
import ProjectDesignAndCustomer from 'components/project/ProjectDesignAndCustomer'
import ProjectSchemesAndDocuments from 'components/project/schemesAndDocuments/ProjectSchemesAndDocuments'
import ProjectMaterialsAndPrices from 'components/project/materialsAndPrices/ProjectMaterialsAndPrices'
import ProjectPlannedResources from 'components/project/plannedResources/ProjectPlannedResources'

import { mapGetters, mapActions, mapMutations } from 'vuex'
export default {
  components: {
    // ButtonContinue,
    ProjectDesignAndCustomer,
    ProjectSchemesAndDocuments,
    ProjectMaterialsAndPrices,
    ProjectPlannedResources,
  },
  name: 'salesProjectCreate',
  data() {
    return {}
  },
  created() {
    if (this.SalesProjectCreateContinue) {
      this.onWorkClientProjectShow(this.$route.params.id)
    } else {
      this.setDefaultDocuments()
      this.setDefaultSchemes()
      this.setDefaultProjectsWorkType()
      this.setDefaultProjectsResponsibleEmployees()
      this.setDefaultProjectsWorkTypePeriod()
    }
  },
  watch: {
    'currentStep'() {
      if (this.currentStep == 1) {
        this.onWorkClientProjectShow(this.$route.params.id)
      }
    },
    checkLoadingStatus() {
      if (this.checkLoadingStatus) {
        this.setLoadingAnimationFullPage(true)
      } else {
        this.setLoadingAnimationFullPage(false)
      }
    },
  },
  computed: {
    ...mapGetters(['companiesConfig']),
    ...mapGetters('workClientProject', ['workClientProjectShow']),
    SalesProjectCreateContinue() {
      return this.$route.name === 'SalesProjectCreateContinue'
    },
    windowWidth() {
      return this.$vuetify.breakpoint.width
    },
    isMobile() {
      return this.windowWidth < 1000
    },
    currentStep() {
      return this.$route.query.step
    },
    checkLoadingStatus() {
      const checkArray = [
        this.$refs.designAndCustomer && this.$refs.designAndCustomer.loadingData,
        this.$refs.schemesAndDocuments && this.$refs.schemesAndDocuments.loadingData,
        this.$refs.materialsAndPrices && this.$refs.materialsAndPrices.loadingData,
        this.$refs.plannedResources && this.$refs.plannedResources.loadingData,
      ]
      return checkArray.find((i) => i === true) ? true : false
    },
  },
  methods: {
    ...mapMutations('workDocsProjectDocuments', ['setDefaultDocuments']),
    ...mapMutations('workDocsProjectSchemes', ['setDefaultSchemes']),
    ...mapMutations('workClientProjectsWorkType', ['setDefaultProjectsWorkType']),
    ...mapMutations('workClientProjectsResponsibleEmployees', [
      'setDefaultProjectsResponsibleEmployees',
    ]),
    ...mapMutations('workClientProjectsWorkTypePeriod', ['setDefaultProjectsWorkTypePeriod']),
    ...mapActions('workClientProject', ['onWorkClientProjectShow']),
    ...mapMutations('workClientProject', ['setWorkClientProjectShow']),
    ...mapMutations(['setLoadingAnimationFullPage']),
    async onStepClick(step) {
      const curentStep = this.currentStep
      const push = () => (curentStep > step ? this.$router.push({ query: { step: step } }) : null)
      push()
    },
    async nextStep() {
      if (!this.SalesProjectCreateContinue) {
        this.$refs.ProjectDesignAndCustomer.onCreateOrUpdate().then(async (response) => {
          await this.$router.push({
            name: 'SalesProjectCreateContinue',
            params: {
              id: response,
            },
            query: {
              step:
                this.companiesConfig.schemes === '0' && this.companiesConfig.documents === '0' &&
                this.companiesConfig.work_type_prices === '0' && this.companiesConfig.extra_work_price === '0'
                  ? '4'
                  : this.companiesConfig.schemes === '0' && this.companiesConfig.documents === '0'
                    ? '3'
                    : '2'
            },
          })
          this.$refs.ProjectDesignAndCustomer.onDownloadData({
            projectId: response,
            update: true,
          })
        })
      } else if (this.currentStep == 1 || !this.currentStep) {
        await this.$refs.ProjectDesignAndCustomer.onCreateOrUpdate().then((resp) => {
          this.$router.push({ query: {
            step: this.companiesConfig.schemes === '0' && this.companiesConfig.documents === '0'
            && this.companiesConfig.work_type_prices === '0' && this.companiesConfig.extra_work_price === '0'
              ? '4'
              : this.companiesConfig.schemes === '0' && this.companiesConfig.documents === '0'
                ? '3'
                : '2'
          } })
        })
      } else if (this.currentStep == 2) {
          
          Promise.all([
            this.$refs.ProjectSchemesAndDocuments.onDocumentsUpdate(),
            this.$refs.ProjectSchemesAndDocuments.onSchemesUpdate(),
          ]).then((resp) => {
            this.$router.push({ query: {
              step: this.companiesConfig.work_type_prices === '0' && this.companiesConfig.extra_work_price === '0' ? '4' : '3'
            } })
          })
        
      } else if (this.currentStep == 3) {
        Promise.all([
          this.$refs.ProjectMaterialsAndPrices.onUpdateExtraPrice(),
          this.$refs.ProjectMaterialsAndPrices.onCreateOrUpdate(),
        ])
          .then((resp) => {
            if (resp.find((i) => i !== true)) {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common['notifications'][
                      'izmeneniya-uspeshno-sohraneny'
                    ],
                  IsError: false,
                },
                { root: true },
              )
            }
            this.$router.push({ query: { step: '4' } })
          })
          .catch((err) => {
            console.log('err', err)
          })
      } else if (this.currentStep == 4) {
         this.$refs.ProjectPlannedResources.onCreateOrUpdate()
          .then((res) => {
          this.$store.dispatch(
            'popup/onMessage',
            {
              message:
                this.localStorage.translations.pages.common['notifications'][
                  'izmeneniya-uspeshno-sohraneny'
                ],
              IsError: false,
            },
            { root: true },
          )
          this.$router.push({ name: 'Sales' })
        })
         .catch((err) => {
           console.log(err)
           this.$store.dispatch(
             'popup/onMessage',
             {
               message: this.localStorage.translations.pages.common.notifications['oshibka'],
               IsError: true,
             },
             { root: true },
           )
         })
      }
    },
  },
  destroyed() {
    this.setWorkClientProjectShow({})
  },
}
</script>

<style lang="scss" scoped>
:deep().wrap {
  .v-stepper {
    background: none !important;
    box-shadow: none !important;
    &__headerBox {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    &__header {
      box-shadow: none;
      width: 100%;
      margin-right: 30px;
      height: auto;
      margin-left: -24px;
      .v-divider {
        display: block;
        // margin: 34px -67px 0;
        // margin: 8px auto;
        border-color: #dbdbdb;
        border: 1px solid #dbdbdb;
        &.complete {
          border: 1px solid #277faf;
        }
      }
    }
    &__step {
      // flex-basis: max-content;
      // position: relative;
      padding: 12px 24px;

      &__step {
        border-color: #dbdbdb !important;
        // order: 2;
        // margin: 10px 0 0;
        width: 18px;
        height: 18px;
        min-width: 18px;
        font-size: 0;
        .v-icon {
          font-size: 0.9rem;
        }
      }
      &--active {
        color: #277faf;
        .v-stepper__step__step {
          background-color: #ffffff !important;
          border-color: #277faf !important;
        }
      }
      &--complete {
        .v-stepper__step__step {
          background-color: #277faf !important;
          border-color: #277faf !important;
        }
      }
      &--editable {
        background: transparent !important;
        &:hover {
          .v-stepper__label {
            color: #16558f !important;
          }
          .v-stepper__step__step {
            background-color: #16558f !important;
            border-color: #16558f !important;
          }
        }
      }
    }
    &__label {
      color: #277faf !important;
      text-shadow: none !important;
      font-size: 1rem !important;
      // white-space: nowrap;
    }
    &__content {
      padding: 30px 0;
    }
    &-mobile {
      .v-stepper {
        &__step {
          padding: 12px 0px;
        }
        &__content {
          padding: 15px 0;
          margin: 0 0 0 7.5px;
        }
        &__wrapper {
          padding-left: 10px;
        }
      }
    }
  }
}

// :deep() .v-stepper__items,
// :deep() .v-stepper__wrapper
// {
//   overflow: visible !important;
// }
</style>
